"use client";

import {
  ANALYTICS_EVENTS,
  track,
  type MarketingCtaId,
} from "@/lib/analyticsEvents";
import Link from "next/link";
import type { ComponentProps, MouseEvent } from "react";

type LinkProps = ComponentProps<typeof Link>;

type MarketingTrackedLinkProps = LinkProps & {
  ctaId: MarketingCtaId;
  ctaLabel: string;
};

function hrefToString(href: LinkProps["href"]): string {
  return typeof href === "string" ? href : String(href);
}

export function MarketingTrackedLink({
  ctaId,
  ctaLabel,
  href,
  onClick,
  children,
  ...props
}: MarketingTrackedLinkProps) {
  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    track(ANALYTICS_EVENTS.marketingCtaClicked, {
      ctaId,
      ctaLabel,
      href: hrefToString(href),
    });
    onClick?.(event);
  };

  return (
    <Link href={href} onClick={handleClick} {...props}>
      {children}
    </Link>
  );
}
